export const translations = {
  title: {
    id: "vehicle.table.card.widget.title",
    defaultMessage: "My fleet",
  },
  loadData: {
    id: "vehicle.table.card.widget.load",
    defaultMessage: "Loading data for the selected company...",
  },
  batchUpload: {
    id: "vehicles.table.upload",
    defaultMessage: "Batch Upload",
  },
  syncHitory: {
    id: "vehicles.table.syncHistory",
    defaultMessage: "Sync & History",
  },
  search: {
    id: "vehicles.table.search",
    defaultMessage: "Search",
  },
  error: {
    title: {
      id: "vehicles.table.card.widget.error.title",
      defaultMessage: "We couldn't load data for this company",
    },
    subtitle: {
      id: "vehicles.table.card.widget.error.subtitle",
      defaultMessage:
        "Please try again in a few moments to refresh the information.",
    },
    actionLabel: {
      id: "vehicles.table.card.widget.error.action",
      defaultMessage: "Try again",
    },
  },
  columns: {
    plate: { id: "plate", defaultMessage: "Plate" },
    name: {
      id: "vehicle.name",
      defaultMessage: "Vehicle name",
    },
    status: {
      id: "vehicles.table.status",
      defaultMessage: "Status",
    },
    ownershipStatus: {
      id: "vehicles.table.ownershipStatus",
      defaultMessage: "Ownership status",
    },
    vehicleBrand: {
      id: "vehicleBrand",
      defaultMessage: "Brand",
    },
    vehicleModel: {
      id: "vehicleModel",
      defaultMessage: "Model",
    }
  },
};
